import gqlTagGira from 'graphql-tag';
import { CREATE_ISSUE_FRAGMENT } from '@atlassian/jira-business-issue-create/src/services/create-issue/gql.tsx';
import { VIEW_ITEM_FRAGMENT } from '../calendar-view-items/gql.tsx';

export const CREATE_ISSUE_MUTATION = gqlTagGira`
mutation JWMCalendarInlineCreateIssue ($input: JiraCreateIssueInput!, $fieldIds: [String]!){
    createJiraBusinessIssue(input: $input, fieldIdsToReturn: $fieldIds) {
        item {
            ...CalendarViewItem
        }
        ...CreateIssueFragment
    }
}
${CREATE_ISSUE_FRAGMENT}
${VIEW_ITEM_FRAGMENT}
`;

export const ISSUE_REFETCH_QUERY = gqlTagGira`
query JWMCalendarInlineCreateRefetchQuery($cloudId: ID!, $jql: String!, $fieldIds: [String]!, $first: Int) {
    jira {
        jwmViewItems(cloudId: $cloudId, jql: $jql, first: $first) {
            ... on JiraWorkManagementViewItemConnection {
                edges {
                    node {    
                        ...CalendarViewItem
                    }
                }
            }        
        }
    }
}
${VIEW_ITEM_FRAGMENT}
`;
